export function leaderboardRankFormatter(value: number): string {
  switch (true) {
    case value < 1_000:
      return String(value);
    case value >= 1_000 && value < 1_000_000:
      return `${Math.floor(value / 1_000)}k+`;
    case value > 1_000_000:
      return `${Math.floor(value / 1_000_000)}M+`;
    case value > 1_000_000_000:
      return `${Math.floor(value / 1_000_000_000)}B+`;
    default:
      return String(value);
  }
}
